import PropTypes from 'prop-types';
import React from 'react';
import AvatarLinked from './AvatarLinked';
import DisplayName from './DisplayName';
import styles from './AvatarNamed.css?module';

class AvatarNamed extends React.Component {
  render() {
    return (
      <div className={styles.container}>
        <AvatarLinked className={styles.avatar} userId={this.props.userId} />
        <DisplayName userId={this.props.userId} />
      </div>
    );
  }
}

AvatarNamed.propTypes = {
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default AvatarNamed;
